module.exports = __webpack_public_path__ + "static/media/minus-key.b36aa844.svg";